import React from 'react';
import '../App.css';
import './HeroSection.css';

function HeroSection() {
  return (
    <div className='hero-container'>
      {/* <img src="/images/dripzebra_by_whereisjambon.jpg" alt="TooRare Logo" /> */}
      {/* <video src='/videos/TMUBRoll.mp4' autoPlay loop muted /> */}
      <h1>RARE DISEASES CLUB</h1>
      <p>Toronto Metropolitan University</p>
      <div className='hero-btns'>
        {/* <Button
          className='btns'
          buttonStyle='btn--outline'
          buttonSize='btn--large'
        >
          GET STARTED
        </Button>
        <Button
          className='btns'
          buttonStyle='btn--primary'
          buttonSize='btn--large'
          onClick={console.log('hey')}
        >
          WATCH TRAILER <i className='far fa-play-circle' />
        </Button> */}
      </div>
    </div>
  );
}

export default HeroSection;